/* eslint-disable func-names,jsx-a11y/no-static-element-interactions */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Headroom from 'react-headroom';
import {NavLink} from "react-router-dom";
import {SlideDown} from 'react-slidedown'
import './LiquidityEdgeHeader.scss';
import {isInternalLink} from "../../helpers/filters";

class LiquidityEdgeHeader extends Component {

    static propTypes = {
        disableHeaderNav: PropTypes.bool,
        disableHeaderLogo: PropTypes.bool,
        // eslint-disable-next-line react/forbid-prop-types
        links: PropTypes.array.isRequired
    };

    static defaultProps = {
        disableHeaderNav: false,
        disableHeaderLogo: false
    };

    state = {
        mobileNavDropDowns: {}
    };

    componentDidMount() {
        /**
         * Handles toggling the navigation menu for small screens and enables TAB key
         * navigation support for dropdown menus.
         */
        let i;
        let len;

        const container = document.getElementById('site-navigation');
        if (!container) {
            return;
        }

        const button = document.getElementById('menu-toggle');
        if (typeof button === 'undefined') {
            return;
        }

        const menu = document.getElementById('mobile-nav');

        const menuMain = document.getElementById('headerNav');
        if (!menuMain) return;

        // Hide menu toggle button if menu is empty and return early.
        if (typeof menu === 'undefined') {
            button.style.display = 'none';
            return;
        }

        // Sibling function
        // const getSiblings = (elem) => {
        // 	const siblings = [];
        // 	let sibling = elem.parentNode.firstChild;
        // 	for (; sibling; sibling = sibling.nextSibling) {
        //         // eslint-disable-next-line no-continue
        // 		if (sibling.nodeType !== 1 || sibling === elem) continue;
        // 		siblings.push(sibling);
        // 	}
        // 	return siblings;
        // };

        const addClassName = (el, className) => {
            const element = el;
            if (element.classList) {
                element.classList.add(className);
            } else {
                element.className = `${element.className}${className}`;
            }
        };

        const removeClassName = (el, className) => {
            const element = el;
            if (element.classList) {
                element.classList.remove(className);
            } else {
                element.className = element.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'), ' ');
            }
        };

        const mobileMenuActivate = () => {
            if (window.matchMedia("(max-width: 768px)").matches) {
                addClassName(button, 'active');
                addClassName(menu, 'active');
            } else {
                removeClassName(button, 'active');
                removeClassName(menu, 'active');
            }
        };

        mobileMenuActivate();
        window.addEventListener("resize", mobileMenuActivate, false);

        menu.setAttribute('aria-expanded', 'false');
        if (menu.className.indexOf('nav-menu') === -1) {
            menu.className += ' nav-menu';
        }

        const closeMenu = () => {
            container.className = container.className.replace(' toggled', '');

            removeClassName(button, 'closed-burger');

            removeClassName(menu, 'open-menu');
            addClassName(menu, 'closed-menu');

            document.body.style.overflow = "auto";
            document.body.style.height = "auto";

            menu.querySelector('a').setAttribute('tabindex', -1);

            button.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-expanded', 'false');

            setTimeout(() => {
                addClassName(button, 'active');
            }, 200);
            setTimeout(() => {
                removeClassName(menu, 'active');
            }, 300);
        };

        // Mobile menu click functionality
        button.onclick = function () {
            if (container.className.indexOf('toggled') !== -1) {
                closeMenu();
            } else {
                container.className += ' toggled';

                removeClassName(button, 'active');
                addClassName(button, 'closed-burger');

                removeClassName(menu, 'closed-menu');
                removeClassName(menu, 'active');
                addClassName(menu, 'open-menu');

                document.body.style.overflow = "hidden";
                document.body.style.height = "100%";

                menu.querySelector('a').setAttribute('tabindex', 0);

                button.setAttribute('aria-expanded', 'true');
                menu.setAttribute('aria-expanded', 'true');
            }
        };

        // Close menu with esc key
        document.onkeydown = (evt=window.event) => {
            // evt = evt || window.event;
            let isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } else {
                isEscape = (evt.keyCode === 27);
            }
            if (isEscape) {
                container.className = container.className.replace(' toggled', '');

                removeClassName(button, 'closed-burger');

                removeClassName(menu, 'open-menu');
                addClassName(menu, 'closed-menu');

                document.body.style.overflow = "auto";
                document.body.style.height = "auto";

                menu.querySelector('a').setAttribute('tabindex', -1);

                button.setAttribute('aria-expanded', 'false');
                menu.setAttribute('aria-expanded', 'false');
            }
        };

        // Get all the link elements within the menu.
        const links = menu.getElementsByTagName('a');
        const subMenus = menu.getElementsByTagName('ul');

        const linksMain = menuMain.getElementsByTagName('a');
        const subMenusMain = menuMain.getElementsByTagName('ul');

        /**
         * Sets or removes .focus class on an element.
         */
        function handleMenuClose()  {
            closeMenu();
        }

        // Set menu items with submenus to aria-haspopup="true".
        for (i = 0, len = subMenus.length; i < len; i += 1) {
            subMenus[i].parentNode.setAttribute('aria-haspopup', 'true');
        }

        for (i = 0, len = subMenusMain.length; i < len; i += 1) {
            subMenusMain[i].parentNode.setAttribute('aria-haspopup', 'true');
        }

        // Each time a menu link is focused or blurred, toggle focus.
        for (i = 0, len = links.length; i < len; i += 1) {
            links[i].addEventListener('click', handleMenuClose, true);
        }

        for (i = 0, len = linksMain.length; i < len; i += 1) {
            linksMain[i].addEventListener('click', handleMenuClose, true);
        }

    }


    /**
     * Recursively fetch nav items
     *
     * @param menuType
     * @param link
     * @param isChild
     * @param index
     * @return {XML}
     */
    getNavItems = (menuType='site', link, isChild=false, index=null) => {
        const dropdowns = this.state.mobileNavDropDowns;
        let navClass = `${menuType}-nav__menu-item`;
        let addChildIndicator = null;
        if (link.links.length) {
            navClass = `${navClass} ${menuType}-nav__menu-item--children`;

            if (menuType === 'mobile') {
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                addChildIndicator = (<i key={`mobile_${index}_${link}`} className={`fal fa-angle-down arrow${dropdowns[index] ? ' open' : ''}`} aria-hidden={!dropdowns[index]} onClick={() => {
                    dropdowns[index] = !dropdowns[index];
                    this.setState({mobileNavDropDowns: dropdowns});
                }} />);
            }

        }
        if (isChild) {
            navClass = `${navClass} ${menuType}-nav__menu-item--child`;
        }

        return (
            <li key={`${index}_${link}`} className={navClass}>

                {isInternalLink(link.url.path) ? (
                    <NavLink activeClassName="active" to={link.url.path} exact>
                        <span>
                            {link.label}
                        </span>
                    </NavLink>
                ) : (
                    <a href={link.url.path}><span>{link.label}</span></a>
                )}



                {addChildIndicator}

                {menuType === 'mobile' ? (
                    <SlideDown closed={!dropdowns[index]}>
                        {this.renderSubNav(link, menuType, dropdowns, index)}
                    </SlideDown>
                ) : this.renderSubNav(link, menuType, dropdowns, index)}

            </li>
        )
    };

    renderSubNav = (link, menuType, dropdowns, index) =>
        link.links.length > 0 ? (
            <ul className={`${menuType}-nav__menu--secondary`}>
                {link.links.filter(childLink => childLink.url.path).map((childLink, childIndex) => this.getNavItems('site', childLink, true, `${index}_${childIndex}`))}
            </ul>
        ) : null;

    render() {
        if (this.props.disableHeaderNav && this.props.disableHeaderLogo) return null;

        return (
            <Headroom style={{
              zIndex: '9999'
            }}>
                <header className="site-header liquidity-edge-header" role="banner">

                    {(!this.props.disableHeaderNav || !this.props.disableHeaderLogo) && (
                        <div id="site-navigation" className="site-header__site-nav">
                            <div className="container">
                                <NavLink to="/trade/us-treasuries" className="site-header__branding" style={this.props.disableHeaderLogo ? {visibility: 'hidden'} : {}}>
                                    <img src="/public/images/global/liquidityedge.svg" alt="Liquidity Edge"/>
                                </NavLink>

                                <nav id="headerNav" className="site-nav__menu--primary nav-menu" style={this.props.disableHeaderNav ? {visibility: 'hidden'} : {}}>
                                    <ul>
                                        {this.props.links.filter(link => link.url.path).map((link, index) => this.getNavItems('site', link, false, index))}
                                    </ul>
                                </nav>

                                <button id="menu-toggle" className="menu-toggle" aria-controls="mobile-menu" aria-expanded="false" style={this.props.disableHeaderNav ? {visibility: 'hidden'} : {}}>
                                    <div className="toggle-icon">
                                        <span className="line line-top"/>
                                        <span className="line line-middle"/>
                                        <span className="line line-bottom"/>
                                    </div>
                                </button>

                                <nav id="mobile-nav" className="headerNav__mobile nav-menu" style={this.props.disableHeaderNav ? {visibility: 'hidden'} : {}}>
                                    <ul className="mobile-nav__menu--primary">
                                        {this.props.links.filter(link => link.url.path).map((link, index) => this.getNavItems('mobile', link, false, index))}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    )}
                </header>
            </Headroom>
        )
    }

}

export default LiquidityEdgeHeader;



// WEBPACK FOOTER //
// ./frontend/components/Header/LiquidityEdgeHeader.jsx